import React from 'react';
import '../styles/pages/ContactSupportPage.css';

function ContactSupportPage() {
  return (
    <div className="contact-support-page">
      <h1>Contact Support</h1>
      <p>If you have any issues or questions, please contact us through one of the following methods:</p>
      <ul>
        <li><strong>Email:</strong> findmydocsteam00@gmail.com</li>
        <li><strong>Phone:</strong> +94 11 222 2222</li>
      </ul>
    </div>
  );
}

export default ContactSupportPage;
